<template>
  <div class="table-wrapper">
    <sb-table :columnDefinitions="columnDefs" :rows="rows" >
      <sb-table-thead slot="sb-table-header" slot-scope="{cols}">
        <sb-table-head v-if="false">{{ cols[0].name }}</sb-table-head>
        <sb-table-head>{{ cols[1].name }}</sb-table-head>
        <sb-table-head v-if="false">{{ cols[2].name }}</sb-table-head>
        <sb-table-head v-if="IsMerchantPlusView">{{ cols[3].name }}</sb-table-head>
        <sb-table-head v-if="IsMerchantPlusView">{{ cols[4].name }}</sb-table-head>        
        <sb-table-head v-if="false">{{ cols[5].name }}</sb-table-head>        
        <sb-table-head>{{ cols[6].name }}</sb-table-head>        
        <sb-table-head v-if="false">{{ cols[7].name }}</sb-table-head>
        <sb-table-head>{{ cols[8].name }}</sb-table-head>        
        <sb-table-head v-if="showActions">{{ cols[9].name }}</sb-table-head>
      </sb-table-thead>
      <sb-table-row slot="sb-table-row" slot-scope="{row}">
        <sb-table-cell v-if="false">{{ row.Country.Id }}</sb-table-cell>
        <sb-table-cell>{{ row.Country.Name }}</sb-table-cell> 
        <sb-table-cell v-if="false">{{ row.PricingRegion.Id }}</sb-table-cell> 
        <sb-table-cell v-if="IsMerchantPlusView">{{ row.PricingRegion.Name }}</sb-table-cell> 
        <sb-table-cell v-if="IsMerchantPlusView">
          <ul style="list-style: none; padding-inline-start: 0px; margin-bottom: 0px;">
            <li v-for="item in row.MasterLocations" :key="item">{{ item }}</li>
          </ul>
        </sb-table-cell> 
        <sb-table-cell v-if="false">{{ row.DomesticPlan.Id }}</sb-table-cell> 
        <sb-table-cell>{{ row.DomesticPlan.Name }}</sb-table-cell> 
        <sb-table-cell v-if="false">{{ row.InternationalPlan.Id }}</sb-table-cell> 
        <sb-table-cell>{{ row.InternationalPlan.Name }}</sb-table-cell> 
        <sb-table-cell v-if="showActions" class="edit-action">
          <a @click.prevent="handleEditPricingPlan(IsMerchantPlusView, row)" href="#">Edit</a>
        </sb-table-cell> 
      </sb-table-row>
    </sb-table>
  </div>
</template>
<script>

export default {
  name: 'UserPlanAssignmentTable',
  components: {
  },
  mixins: [],
  props: {
    rows: {
      type: Array,
      default: () => ([])
    },
    showActions: {
      type: Boolean,
      default: true
    },
    IsMerchantPlusView: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    columnDefs: [
      { name: 'CountryId', field: 'coutryid' },
      { name: 'Country', field: 'coutryname' },      
      { name: 'Pricing Region Id', field: 'pricingregionid'},
      { name: 'Network Pricing', field: 'pricingregionname'},
      { name: 'Merchant+ Locations', field: 'merchantpluslocations'},
      { name: 'DomestiPlanId', field: 'domesticplanid' },
      { name: 'Domestic Plan', field: 'domesticplanname' },
      { name: 'International Plan Id', field: 'internationplannameid' },
      { name: 'International Plan', field: 'internationplanname' },     
      { name: 'Action', field: 'action' }
    ]
  }),
  mounted () {},
  destroyed () {},
  watch: {},
  computed: {},
  methods: {
    handleEditPricingPlan(IsMerchantPlusView, row) {
      this.$emit('handleEditPricingPlan', IsMerchantPlusView, row)
    }
  },
  directives: {},
  filters: {}
}
</script>
<style scoped>
.table th {
  font-size: 0.875rem;
}
.edit-action a {
  font-weight: 600;
  text-decoration: none;
}
</style>